export const TokenValidationConstants = {
    TOKEN_REFRESH_TIME_REMAINING_SECONDS: 5 * 60,
    TOKEN_HEARTBEAT_INTERVAL_SECONDS:  60
};